import React from "react";
import "./video.css";
import ReactPlayer from "react-player";
import Zoom from "react-reveal/Zoom";
import Video1 from "../../Video/VSL1.mp4";

const Video = () => {
  const data = [
    {
      id: 1,
      url: Video1,
      title: "Our Work Speaks For Us",
      content: "We Value our Farmers, Customers and Partners",
    },

    {
      id: 2,
      url: Video1,
      title: "Our Work Speaks For Us",
      content: "We Value our Farmers, Customers and Partners",
    },

    {
      id: 3,
      url: Video1,
      title: "Our Work Speaks For Us",
      content: "We Value our Farmers, Customers and Partners",
    },

    {
      id: 4,
      url: Video1,
      title: "Our Work Speaks For Us",
      content: "We Value our Farmers, Customers and Partners",
    },

    {
      id: 5,
      url: Video1,
      title: "Our Work Speaks For Us",
      content: "We Value our Farmers, Customers and Partners",
    },

    {
      id: 6,
      url: Video1,
      title: "Our Work Speaks For Us",
      content: "We Value our Farmers, Customers and Partners",
    },
  ];

  return (
    <div className="container video" id="video">
      <div className="section_title">
        <h5>Video</h5>
        <span className="line"></span>
      </div>
      <div className="row">
        {data.map((item, index) => (
          <Zoom>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="video-details" key={index}>
                <ReactPlayer
                  url={item.url}
                  loop={true}
                  controls
                  playing={false}
                  width="auto"
                  height="250px"
                />
                <div className="video-content">
                  <h6>{item.title}</h6>
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          </Zoom>
        ))}
      </div>
    </div>
  );
};

export default Video;
